import { NumericFormat } from 'react-number-format'

export function CustomDecimalInput(props) {
  return (
    <NumericFormat
      allowNegative={false}
      allowLeadingZeros={false}
      thousandSeparator="."
      className="form-control"
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale={true}
      {...props}
    />
  )
}

export function CustomIntegerInput(props) {
  return (
    <NumericFormat
      allowNegative={false}
      className="form-control"
      {...props}
    />
  )
}
